import {
    DisabledCustomerError,
    DisabledStatusError,
    LicenseNotExistError,
    SchoolNotFoundError,
    UnexpectedError,
    UserNotFoundInNameListError,
} from '@/errors';

export const createLambdaError = (lambdaErrorCode?: string) => {
    switch (lambdaErrorCode) {
        case 'DISABLED_CUSTOMER':
            return new DisabledCustomerError();
        case 'NEED_STATUS_ACTIVE':
            return new DisabledStatusError();
        case 'NOT_FOUND_USER':
        case 'NOT_FOUND_ID_PROVIDER_USER':
            return new UserNotFoundInNameListError();
        case 'NOT_FOUND_SCHOOL_ID':
            return new SchoolNotFoundError();
        case 'LICENSE_NOT_EXIST':
        case 'PURCHASE_ORDER_NOT_EXIST':
            return new LicenseNotExistError();
        default:
            return new UnexpectedError();
    }
};
